import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { WardModel } from '../model/masters/ward.model';
import { AssemblyModel } from '../model/masters/assembly.model';
import { ReprintreferenceModel } from '../model/masters/reprintReference.model';
import { ResponseMessage } from '../model/FormsEntity/response';
import { GenderModel } from '../model/masters/gender.model';
import { UserRole } from '../model/masters/userRoleList.model';
import { MeetingSchedule } from '../model/FormsEntity/meetingSchedule.model';
import { GetTimeSlots } from '../model/masters/getTimeSlots.model';
import { MeetingSlotsTiming } from '../model/FormsEntity/meetingSlotsTiming.model';
import { AtrSeekAppointment } from '../model/FormsEntity/AtrSeekAppointment.model';
import { AvlBookedDateSeekApp } from '../model/masters/seekAppAvlBookedDate.model';
import { ReprintReferenceOrSeekAppoReqEnt } from '../model/FormsEntity/ReprintReferenceReqEnt';
import { RolesModel } from '../model/masters/role.model';
import { environment } from '../../environments/environment';
import { UserOfficeModel } from '../model/FormsEntity/UserOfficeModel';
import { Observable } from 'rxjs';
import { PhFeedbackModel } from '../model/masters/phFeedback.model';

//const userUrl=window.location.protocol+'//localhost:8081//dda//masterData//';

@Injectable({ providedIn: 'root' })

export class PersonalHearingService {


  private usersUrl: string;
  private usersUrl1: string;
  private meetingsch: string
  private documentUrl: string
  //private usersUrl2: string;

  constructor(private http: HttpClient) {
    this.usersUrl = environment.baseUrl + 'masterData/';
    this.usersUrl1 = environment.baseUrl + 'personalHearing/';
    this.meetingsch = environment.baseUrl + 'meetingSchedule/';
    this.documentUrl = environment.baseUrl + 'fileUtils/getDownloadedFile';
    //this.usersUrl2 = environment.baseUrl + 'personalHearing/workflow/';

  }
  public getWardList(value) {
    return this.http.get<WardModel>(this.usersUrl + 'getWardList');
  }
  public getGenderList(value) {
    return this.http.get<GenderModel>(this.usersUrl + 'getGenderList');
  }

  public getSeekAppointmentDetailsByAppointmentId(seekAppointmentId) {
    return this.http.get<ReprintreferenceModel>(this.usersUrl1 + 'getSeekAppointmentDetailsByAppointmentId/' + seekAppointmentId)
  }

  /*  public getSeekAppointmentDetailsByFromToDate(date1,date2){
   //  alert("getSeekAppointmentDetailsByAppointmentId servie");
     // return this.http.get<ReprintreferenceModel>(this.usersUrl1 + 'getSeekAppointmentDetailsByAppointmentId/'+seekAppointmentId)
    }
 */



  public getAssemblyList(value) {
    return this.http.get<AssemblyModel>(this.usersUrl + 'getAssemblyList');
  }
  public getSeekAppointmentList(userId) {

    return this.http.get<ReprintreferenceModel[]>(this.usersUrl1 + 'getSeekAppointmentList/' + userId);
  }
  /* public getCloseSeekAppointmentList(userId){
     return this.http.get<ReprintreferenceModel>(this.usersUrl1 + 'getCloseSeekAppointmentList/'+userId);
   } */

  public getCloseSeekAppointmentList(seekAppoitment) {

    return this.http.post<ResponseMessage[]>(this.usersUrl1 + 'getCloseSeekAppointmentList', seekAppoitment);
  }

  public getSeekAppointmentUserDepListbyUserId(userId) {
    return this.http.get<ReprintreferenceModel[]>(this.usersUrl1 + 'getSeekAppointmentUserDepListbyUserId/' + userId);
  }

  public getSeekAppointmentUserDepList(seekAppoitment) {

    return this.http.post<ResponseMessage[]>(this.usersUrl1 + 'getSeekAppointmentUserDepList', seekAppoitment);
  }


  public getAtrViewSeekAppointmentList(viewAtr) {
    return this.http.post<ResponseMessage[]>(this.usersUrl1 + 'getAtrViewSeekAppointmentList', viewAtr);
  }


  public submitSeekAppointment(seekAppoitment) {
    console.log(seekAppoitment)
    return this.http.post<ResponseMessage>(this.usersUrl1 + 'submitSeekApooitent', seekAppoitment);
  }
  public transferSeekAppointment(seekAppoitment) {
    return this.http.post<ResponseMessage>(this.usersUrl1 + 'transferSeekApooitent', seekAppoitment);
  }
  public atrTransferSeekApooitent(seekAppoitment) {
    return this.http.post<ResponseMessage>(this.usersUrl1 + 'atrTransferSeekApooitent', seekAppoitment);
  }
  public submitReschduleAppointment(seekAppoitment) {
    return this.http.post<ResponseMessage>(this.usersUrl1 + 'submitReschduleAppointment', seekAppoitment);
  }
  public cancelReschduleAppointment(seekAppoitment) {

    return this.http.post<ResponseMessage>(this.usersUrl1 + 'cancelReschduleAppointment', seekAppoitment);
  }

  public generatePdfForSeekAppointment(rePrintRefrence) {

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
      //'responseType'  : 'blob' as 'json'        //This also worked
    };
    return this.http.post<any>(this.usersUrl1 + 'generatePdfForSeekAppointment', rePrintRefrence, httpOptions);
  }

  public printMISReport(rePrintRefrence) {
    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
      //'responseType'  : 'blob' as 'json'        //This also worked
    };
    return this.http.post<any>(this.usersUrl1 + 'generatePdfForMISReport', rePrintRefrence, httpOptions);
  }



  public getdeptuserList() {
    return this.http.get<RolesModel>(this.usersUrl1 + 'getDesignationList')
  }

  public getdeptuserListofMIS(multidepartmentsList) {
    return this.http.get<any>(this.usersUrl1 + 'getDeptDesigUserListAll/' + multidepartmentsList)
  }


  public getOfficerNameList(designationName, department) {
    return this.http.get<UserRole>(this.usersUrl1 + 'getOfficerNameList/' + designationName + '/' + department)
  }

  /* public getOfficerNameList(multidepartmentsList,multiDesignationName){
     //alert("getOfficerNameList service");
     return this.http.get<UserRole>(this.usersUrl1 + 'getOfficerNameListDeptdesig/'+multidepartmentsList+'/'+multiDesignationName)
   } */

  public getAllOfficerNameListofMIS(userOfficeModel) {

    return this.http.post<any>(this.usersUrl1 + 'getOfficernameIdDeptDesigList', userOfficeModel)
  }

  /* public searchSeekAppointmentList(d1,d2,userId){
     
     return this.http.get<ReprintreferenceModel[]>(this.usersUrl1 + 'searchListofAppointments/'+d1+'/'+d2+'/'+userId)
   }
   */

  public searchSeekAppointmentList(d1, d2, selectedDepartment, officerNameSelList) {

    return this.http.get<ReprintreferenceModel[]>(this.usersUrl1 + 'searchListofAppointmentsForMis/' + d1 + '/' + d2 + '/' + selectedDepartment + '/' + officerNameSelList)
  }


  public getDeptListAll() {
    return this.http.get<any>(this.usersUrl1 + 'getDeptListAll');
  }


  public getMeetingTimeSlots(getTimeSlots) {

    return this.http.post<MeetingSlotsTiming>(this.usersUrl1 + 'getMeetingTimeSlots', getTimeSlots)
  }

  public getTransferMeetingTimeSlots(getTimeSlots) {

    return this.http.post<MeetingSlotsTiming>(this.usersUrl1 + 'getTransferMeetingTimeSlots', getTimeSlots)
  }

  public getRescTimeSlots(getTimeSlots) {

    return this.http.post<MeetingSlotsTiming>(this.usersUrl1 + 'getRescTimeSlots', getTimeSlots)
  }


  public getOfficerId(seekAppointmentId) {


    return this.http.get<ReprintreferenceModel>(this.usersUrl1 + 'getOfficerId/' + seekAppointmentId)
  }
  public getDeptUserLists() {

    return this.http.get<Object>(this.usersUrl1 + 'getDeptUserLists');
  }


  public closeSeekAppointment(seekAppoitment) {
    return this.http.post<ResponseMessage>(this.usersUrl1 + 'closeSeekAppointment', seekAppoitment);
  }


  public getAtrSeekAppointmentList(userId) {
    return this.http.get<ReprintreferenceModel>(this.usersUrl1 + 'getAtrSeekAppointmentList/' + userId);
  }

  public getAtrSeekAppointmentSearchList(seekAppoitment) {
    return this.http.post<ReprintreferenceModel[]>(this.usersUrl1 + 'getAtrSeekAppointmentListSearch', seekAppoitment);
  }

  public saveAtrSeekAppointment(atrSeek) {

    return this.http.post<ResponseMessage>(this.usersUrl1 + 'saveAtrSeekAppointment', atrSeek);
  }
  public getListForDataShow(userId) {
    return this.http.get<any>(this.usersUrl1 + 'getListForDataShow/' + userId);
  }

  public getAvailabeBookedDate(value) {

    return this.http.get<AvlBookedDateSeekApp>(this.usersUrl1 + 'getAvaBookedDateSeekApp/' + value);
  }


  public getatrList(value) {


    return this.http.get<ReprintreferenceModel>(this.usersUrl1 + 'getAtrRecordSeekAppointmentList/' + value);
  }
  public slotsDataMis(fromDate, toDate) {
    console.log(fromDate, toDate)
    return this.http.get<any>(this.usersUrl1 + 'misReportForPHDept/' + fromDate + '/' + toDate);
  }

  // public generateImage(any){
  //   return this.http.post<any>(this.usersUrl1 + 'getDownloadedFileForChangeRequest',any);
  // }
  public generateImage(fileName) {
    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'

    };
    return this.http.post<any>(this.documentUrl, fileName, httpOptions);
  }
  public approveRejSlotsByDeptUser(data) {
    return this.http.post<ResponseMessage>(this.meetingsch + 'approveRejSlotsByDeptUser', data);
  }
  saveFeedback(PhFeedbackModel: PhFeedbackModel): Observable<ResponseMessage> {

    return this.http.post<ResponseMessage>(`${this.usersUrl1}saveFeedback`, PhFeedbackModel);
  }

}

